export default __webpack_public_path__ + "static/media/penne.f7e2a06b.svg";